"use client";

import Link from "@/components/Link";
import type { Article } from "@/lib/articles";
import { formatArticleDate, stripHtml } from "@/lib/articles";
import CountryFlag from "./CountryFlag";
// Higher-specificity overrides so the legacy `.blog-box` theme rules don't
// corrupt the card once the production CSS bundle reorders the cascade.
import "./article-card.css";

export interface ArticleCardProps {
  title: string;
  photo: string;
  href: string;
  date: string;
  destinationName?: string;
  excerpt?: string;
}

export function toArticleCardProps(article: Article): ArticleCardProps {
  return {
    title: article.pageContent.title,
    photo: article.pageContent.headerPhoto || "/central.jpg",
    href: `/Article/${article.pageSEO.pageURL}`,
    date: article.createdDate,
    excerpt: stripHtml(article.pageContent.description, 150),
  };
}

export default function ArticleCard(props: ArticleCardProps) {
  return (
    <div className="blog-box th-ani article-card">
      <div className="blog-img global-img">
        <Link href={props.href} title={props.title} style={{ display: "block", lineHeight: 0 }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={props.photo} alt={props.title} loading="lazy" decoding="async" />
        </Link>
      </div>
      <div className="blog-box_content">
        <div className="blog-meta">
          <span>
            <i className="far fa-clock"></i>{" "}
            {formatArticleDate(props.date)}
          </span>
          {props.destinationName && (
            <span>
              <CountryFlag
                country={props.destinationName}
                fallback={<i className="fa-solid fa-location-dot" style={{ marginRight: 6 }}></i>}
              />
              {props.destinationName}
            </span>
          )}
        </div>
        <h3 className="box-title">
          <Link href={props.href} title={props.title}>{props.title}</Link>
        </h3>
        {props.excerpt && (
          <p className="blog-text">{props.excerpt}</p>
        )}
        <Link
          href={props.href}
          className="th-btn style4 th-icon"
          title={`Read More about ${props.title}`}
        >
          Read More
          <span className="visually-hidden">{` about ${props.title}`}</span>
        </Link>
      </div>
    </div>
  );
}
